// export let url = "http://localhost:8080/";
export let url = "https://backend.skillserve.in/";

// src/helper/url_helper.js
// export const LAUNCH_COURSE = "http://backend.skillserve.in/launch-scorm";
export const LAUNCH_COURSE = url+ "launch-scorm";

// Authentication

export const STUDENT_LOGIN = url + "loginStudent";
export const TATASTUDENT_TataLOGIN = url + "tataloginStudent";
export const STUDENT_REGISTER = url + "registerStudent";
export const GET_SINGLE_SUTDENT = url + "getSingleStudent/";
export const UPDATE_STUDENT = url + "updateStudent";
export const FORGOT_PASSWORD = url + "student-forgot-password/";
export const RESET_PASSWORD = url + "reset-student-password";

//Otp

export const OTP_SEND = url + "sendOtp";
export const OTP_VERIFY = url + "verifyOtp";


// Course
export const GET_ALL_PUBLIC_COURSES = url + "getAllPublicCourses";
export const FETCH_SINGLE_COURSE = url + "getSingleCourse/";
export const GET_FILTER_COURSE = url + "getFilterCourse";
export const SEARCH_COURSE = url + "searchCourses/";
// In your url_helper.js file
// export const ENROLL_FREE_COURSE = url+ "addFreeCourseToStudent/";

export const ENROLL_FREE_COURSE = url + "addFreeCourseToStudent";

// Scrom Course 
// export const LAUNCH_COURSE = url + "launch-scorm";

// module 
export const FETCH_ALL_MODULE__OF_COURSE = url + "getAllModuleOfCourse";



// Category

export const FETCH_ALL_CATEGORY = url + "getAllCategory"

// Sub Category
export const FETCH_ALL_SUBCATEGORY = url + "getAllSubCategory"

export const GET_ALL_SUBCATEGORIES_BASED_ON_CATEGORIES = url + "getAllSubCategoriesBasedOnCategories";


// Levels
export const FETCH_ALL_LEVEL = url + "getAllLevel";


// Content routes 

export const GENERATE_PRE_SIGNED_URL = url + "generatePreSignedUrl";
export const GENERATE_PRE_SIGNED_URL_FOR_ACCESS = url + "generatePresignedUrlForAccess";
export const GENERATE_PRE_SIGNED_URL_FOR_PROCESS_CONTENT_ACCESS = url + "generatePresignedUrlForProcessContentAccess";


// Assessment 
export const GET_QUESTION_BY_ASSESSMENT = url + "getQuestionByAssessment";




// Student

export const GET_ALL_COURSE_OF_STUDENT = url + "getAllCourseOfStudent/";
export const GET_ALL_SCORM_COURSE_OF_STUDENT = url + "getAllScormCoursesOfStudent/";
export const GET_ALL_CLASSES_OF_STUDENT = url + "getAllClassesOfStudent/";
export const GET_ALL_EXAMS_OF_STUDENT = url + "getAllExamOfStudent/";
export const GET_ALL_MY_COURSES = url + "getAllMyCourses";


// Module Progress

export const UPDATE_PROGRESS = url + "updateProgressForStudent/";
export const GET_STUDENT_PROGRESS = url + "getStudentProgress/";

export const SUBMIT_ASSESSMENT_FOR_STUDENT = url + "submitAssessmentForStudent/";


// Payment

export const CREATE_ORDER = url + "create-order";
export const VERIFY_PAYMENT = url + "verify-payment";


// Feedback
export const GET_ALL_FEEDBACK_OF_STUDENT = url + "getAllFeedbackOfStudent/";
export const SAVE_FEEDBACK_RESPONSE = url + "saveFeedbackResponse";


// Certificate
export const VERIFY_CERTIFICATE = url + "api/certificate/verify/";



// Tata Dashboard endpoints
export const GET_TATA_DASHBOARD_DATA = url + "getTataDashboardData";
export const GET_ALL_DIVISIONS = url + "getDivisions"; // Add this line


